import { Badge, Button } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { FixedPageTitle } from '@/components/layout/PageWithFixedToolbar/FixedPageTitle'

type DeploymentEditorToolbarProps = {
  applicationName?: string
  mode: 'create' | 'edit'
  onCancelEdit: () => void
}

export const DeploymentEditorToolbar = ({
  applicationName,
  mode,
  onCancelEdit
}: DeploymentEditorToolbarProps) => {
  return (
    <FixedPageTitle
      title={
        mode === 'edit' ? (
          <FormattedMessage id="deployments.editor.update" />
        ) : (
          <FormattedMessage id="deployments.editor.create" />
        )
      }
      leftSection={
        applicationName && (
          <Badge color="brand-primary">{applicationName}</Badge>
        )
      }
      rightSection={
        <Button variant="light" color="red" onClick={onCancelEdit}>
          <FormattedMessage id="deployments.editor.cancel" />
        </Button>
      }
    />
  )
}
